<template>
    <div class="page-deliver-exc-edit">
        <div class="pg-breadcrumb">
            <div class="breadcrumb-item em">珠海倉庫</div>
            <div class="breadcrumb-item">異常件</div>
        </div>

        <div class="pg-block">
            <Spin fix class="pg-sub-loading" v-if="isSubmiting">
                <Icon type="ios-loading" :size="20" class="demo-spin-icon-load"></Icon>
                <div class="loading-text">Loading</div>
            </Spin>

            <div class="pg-form-wrap">
                <Row>
                    <Col span="11" push="5">
                        <Form :label-width="150">
                            <FormItem>
                                <div slot="label" class="form-label">
                                    <em class="red">* </em>
                                    <span>異常原因</span>
                                </div>
                                <Input v-model="form.reason"></Input>
                            </FormItem>

                            <FormItem>
                                <div slot="label" class="form-label">
                                    <em class="red">* </em>
                                    <span>異常處理</span>
                                </div>
                                <Input type="textarea" v-model="form.handle"></Input>
                            </FormItem>

                            <FormItem>
                                <div class="pg-btn-wrap">
                                    <div class="pg-btn style1" @click="handleCheckForm">確定</div>
                                    <div class="pg-btn" @click="handleBack">返回</div>

                                </div>
                            </FormItem>
                        </Form>
                    </Col>
                </Row>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        data()
        {
            return {
                pageParam: {},
                detail: {},
                form: {
                    reason: '',
                    handle: ''
                },
                isSubmiting: false
            };
        },
        mounted()
        {
            this.pageParam = this.$route.query;
            this.getDetail();
        },
        methods: {
            handleBack()
            {
                this.$router.go(-1);
            },

            getDetail()
            {
                this.$Rq.requestAuth({
                    url: this.$Api.deliverExcList + '/' + this.pageParam.id,
                    method: 'get'
                }).then((res) =>
                {
                    if (res.code == 0)
                    {
                        let resData = res.data;
                        this.detail = resData;
                        this.form = {
                            reason: resData.abnormal.describe,
                            handle: resData.abnormal.handle
                        }
                    }
                });
            },

            handleCheckForm()
            {
                let form = this.form;
                if (form.reason === '')
                {
                    this.$Utils.showTipInfo('請輸入異常原因');
                    return;
                } else if (form.handle === '' || form.handle === null)
                {
                    this.$Utils.showTipInfo('請輸入異常處理');
                    return;
                }

                this.handleSubmit();

            },
            handleSubmit()
            {
                let form = this.form;
                this.isSubmiting = true;

                this.$Rq.requestAuth({
                    url: this.$Api.deliverExcEdit,
                    method: 'post',
                    data: {
                        odd_numbers: this.detail.odd_numbers,
                        reason: form.reason,
                        handle: form.handle
                    }
                }).then((res) =>
                {
                    this.isSubmiting = false;

                    if (res.code == 0)
                    {
                        this.$Utils.showSuccess(res.msg);
                    } else
                    {
                        this.$Utils.showTipInfo(res.msg);
                    }
                }).catch((err) =>
                {
                    this.isSubmiting = false;
                });
            }
        }
    };
</script>

<style lang="scss" scoped>
    @import "DeliverExcEdit.scss";
</style>